/* eslint-disable react/react-in-jsx-scope */

const Topbar = () => {
  return <div className='d-flex align-items-center flex-shrink-0'></div>
}

export {Topbar}
